import { Button } from "@/components/ui/button";
import { LoadingCard } from "@/components/LoadingCard";
import { useTranslation } from "react-i18next";

interface BackendUnavailableCardProps {
  onRetry: () => void;
}

export const BackendUnavailableCard = ({ onRetry }: BackendUnavailableCardProps) => {
  const { t } = useTranslation();

  return (
    <LoadingCard
      fullScreen
      showIndicator={false}
      message={t('auth.backendUnavailable.title')}
      description={t('auth.backendUnavailable.description')}
    >
      <Button type="button" onClick={onRetry}>
        {t('common.retry')}
      </Button>
    </LoadingCard>
  );
};
